import React, { forwardRef } from 'react';
import { InfoIcon } from 'lucide-react';
import { Tooltip } from './Tooltip';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
  infoTooltip?: string;
  required?: boolean;
}
export const Input = forwardRef<HTMLInputElement, InputProps>(({
  label,
  error,
  helperText,
  infoTooltip,
  required,
  className = '',
  ...props
}, ref) => {
  return <div className="w-full" data-id="element-716" data-mp="14j8f2p89fn0x">
        {label && <div className="flex items-center mb-2" data-id="element-717" data-mp="14luj4evxzkee">
            <label className="block text-sm font-semibold text-gray-900" data-id="element-718" data-mp="19il7rqltbobf">
              {label}
              {required && <span className="text-red-500 ml-1" data-id="element-719" data-mp="1dlhiyw90wi5c">*</span>}
            </label>
            {infoTooltip && <Tooltip content={infoTooltip} data-id="element-720" data-mp="2kx8c9sfq0ykh">
                <button type="button" className="ml-2 text-gray-400 hover:text-[#007AFF] focus:outline-none" data-id="element-721" data-mp="2ozldc3jiw8ax">
                  <InfoIcon className="w-4 h-4" data-id="element-722" data-mp="2m10r5ce7ntjx" />
                </button>
              </Tooltip>}
          </div>}
        <input ref={ref} className={`w-full px-4 py-3 bg-white border-2 rounded-xl outline-none transition-all duration-200 text-gray-900 placeholder-gray-400
            ${error ? 'border-red-300 focus:border-red-500 focus:ring-2 focus:ring-red-200' : 'border-gray-200 focus:border-[#007AFF] focus:ring-2 focus:ring-[#E6F2FF] hover:border-gray-300'} ${className}`} {...props} data-id="element-723" data-mp="2c3m9j9gjwyq1" />
        {error && <p className="mt-2 text-sm text-red-500" data-id="element-724" data-mp="1tcd1l4mfii0k">{error}</p>}
        {helperText && !error && <p className="mt-2 text-sm text-gray-500" data-id="element-725" data-mp="1oetav58jocrq">{helperText}</p>}
      </div>;
});
Input.displayName = 'Input';